import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AudioPreviewDialog } from '../../components/AudioPreviewDialog';
import { AppStyles } from '../../styles/AppTheme';
// import { AppHelper } from '../../helpers/AppHelper';

export class PlaylistItems extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.pageKey = 'PlaylistItems'
    this.itemId = this.props.match.params.id
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: '/admin' },
      { title: Helper.getString('audio-ads'), to: '/admin/audio-ads' },
      { title: Helper.getString('media') },
    ]
    this.entityAttrName = 'items'
    this.toFetch = [
      { method: 'GET', paths: ['playlists', this.itemId], queryParams: { pb: 'fieldDefPlaylistItems' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      'Play Order': (current) => current.order,
      Info: (current) => current.title,
      Status: (current) => {
        return UiHelper.itemStatusContainer(current)
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
    this.addNewLabel = 'Add Media'
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDefPlaylistItems;
    const item = results[0]
    this.pageTitle = item.title
    const items = item ? Helper.sortAscending(Helper.dictToArray(item.items)) : []
    this.setState({
      items
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = true
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'add', entityAttrName: this.entityAttrName },
      apiEndPoint: ApiHelper.makeUrlPath(['playlists', this.itemId]),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'del', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['playlists', this.itemId]),
    });
  }

  onEdit(current) {
    this.formDefinition.steps[0].fields.find(i => i.key === 'iType').disabled = true
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'edit', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['playlists', this.itemId]),
    });
  }

  // customSubmit(options) {
  //   const { formData, caller } = options
  //   if (formData.order) {
  //     formData.order = AppHelper.padNumberWithZeros(parseInt(formData.order))
  //     if (formData.order.length > 3) {
  //       caller.setState({
  //         fetchState: ApiHelper.State.ERROR,
  //         errMsg: Helper.getString('displayOrderLength'),
  //         message: Helper.getString('displayOrderLength'),
  //         success: false,
  //         inProcess: false
  //       })
  //       return
  //     }
  //   }
  //   ApiHelper.call({
  //     method: 'put', paths: ['playlists', this.itemId],
  //     jsonBody: { ...formData }
  //   }, (err, result) => {
  //     if (err) {
  //       const errorMessage = Helper.getErrorMsg(err)
  //       caller.setState({
  //         fetchState: ApiHelper.State.ERROR,
  //         errMsg: errorMessage,
  //         success: false,
  //         message: errorMessage,
  //         inProcess: false
  //       })
  //       return
  //     } else {
  //       this.setState({ modalOpen: false })
  //       this.fetchItems()
  //       return
  //     }
  //   })
  // }

  renderAboveTable() {
    if(!this.state.preview) return ''
    return (
      <AudioPreviewDialog
        title={this.state.current.title}
        isOpen={this.state.preview ? true : false}
        audio={this.state.current.content}
        onClosed={() => this.setState({ preview: undefined })}
      />
    )
  }

  onActions(current) {
    const actions = []
    actions.push(
      <Tooltip title='Preview' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          {/* <i className='material-icons-outlined' onClick={() => {this.setState({preview: true, current})}}>visibility</i> */}
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true,  current  }) }} />
        </span>
      </Tooltip>
    )
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(UiHelper.buttonDelete(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  actionIconImage:{
    width: 20,
    height: 20
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/PlaylistItems.js